export type LabelSize = {
	displayName: string;
	labelSize: string;
};

export const labelSizes = [
	{ displayName: "Full Page - 8.5 x 11", labelSize: "fullPage" },
	{ displayName: "Avery 5164", labelSize: "avery5164" },
] as const;

export const flaggedLabelSizes = [
	{ displayName: "Full Page - 8.5 x 11", labelSize: "fullPage" },
	{ displayName: "Avery 5164", labelSize: "avery5164" },
	{ displayName: "4 x 6", labelSize: "4x6" },
] as const;

export const defaultLabelSize: LabelSize = {
	displayName: "Full Page - 8.5 x 11",
	labelSize: "fullPage",
};
